import React, { useRef, useState, useEffect } from 'react';
import './ProjectManager.css';
import AssignManager from '../../components/assignmanager/assignmanager';
import { useSmarkDispatch, useSmarkState } from '../../Context/KeycloakContext';
import Header from '../../components/header/headercontainer';
const ProjectManager= (props) => {
    const contextDetails = useSmarkState();
    
  

    return (
        <div>
             <Header />
            <AssignManager isAdmin={contextDetails.isAdminUser} userId={contextDetails.userId}></AssignManager>
            
      </div>
        
    )
}

export default ProjectManager;
